import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Stack,
  Text,
  StackDivider,
  SimpleGrid,
  Image,
} from "@chakra-ui/react";
import React from "react";

export default function ConnectWalletPopup() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button
        p={8}
        bg="brand.500"
        fontSize={{ base: "13px", lg: "20px" }}
        color="white"
        _hover={{ bg: "brand.400" }}
        my={4}
        borderRadius={10}
        onClick={onOpen}
      >
        Connect Wallet
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
        <ModalOverlay />
        <ModalContent >
          <ModalHeader
            bg="#EEEEEE"
            py={6}
            fontSize="23px"
            fontWeight="semibold"
          >
            Connect Wallet
          </ModalHeader>
          <ModalCloseButton
            mt={4}
            mr={6}
            bg="#c5c5c5"
            color="white"
            borderRadius="20px"
          />
          <ModalBody overflowY="auto" maxHeight="100vh">
            <Stack p={12} gap={10} divider={<StackDivider color="inherit" />}>
                <SimpleGrid columns={2} w="full" gap={16} py={4}>
                    <Stack justifyContent="space-between" gap={4} alignItems="center">
                        <Stack height="70px" justifyContent="center">

                        <Image src="/images/checkout/metamask.png"  />
                        </Stack>
                        <Text fontSize="21px" fontWeight="semibold">
                            Metamask
                        </Text>
                    </Stack>
                    <Stack justifyContent="space-between" gap={4} alignItems="center">
                        <Stack height="70px" justifyContent="center">

                        <Image src="/images/checkout/trustwallet.png"  />
                        </Stack>
                        <Text fontSize="21px" fontWeight="semibold">
                            Trustwallet
                        </Text>
                    </Stack>
                    <Stack justifyContent="space-between" gap={4} alignItems="center">
                        <Stack height="70px" justifyContent="center">

                        <Image src="/images/checkout/walletconnect.png"  />
                        </Stack>
                        <Text fontSize="21px" fontWeight="semibold">
                            Walletconnect
                        </Text>
                    </Stack>
                    <Stack justifyContent="space-between" gap={4} alignItems="center">
                        <Stack height="70px" justifyContent="center">

                        <Image src="/images/checkout/more.png"  />
                        </Stack>
                        <Text fontSize="21px" fontWeight="semibold">
                            More
                        </Text>
                    </Stack>
                </SimpleGrid>
                <Text
color="#c5c5c5"
// py={10}
fontSize="18px"
fontWeight="semibold"
align="center"
                >
Haven't got a crypto wallet yet?
                </Text>
            </Stack>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
